import useAuthStore from '../stores/authStore'

export const getAuthToken = () => {
  return useAuthStore.getState().token
}

export const handleTokenExpiration = () => {
  const { logout, setSessionExpired } = useAuthStore.getState()
  logout()
  setSessionExpired(true)
  window.location.href = '/auth'
}

export const formatAuthHeader = (token) => {
  return token ? `Bearer ${token}` : ''
} 